import { ColorTokens, IconSizeTokens, TypographyTypeDLS } from '@voltmoney/schema';
import React from 'react';
import { View, StyleSheet } from 'react-native';
import Icon from '../../icon/Icon';
import Typography from '../../typography/Typography';
const InterestContent = ({ icon, description, }) => {
    return (React.createElement(View, { style: { marginTop: 8, paddingVertical: 8, paddingLeft: 8, flexDirection: 'row', alignItems: 'center', borderColor: '#D0D6F5', borderRadius: 12, borderWidth: 1, backgroundColor: 'white', marginHorizontal: 16 } },
        React.createElement(Icon, { name: icon, size: IconSizeTokens.XXXL, color: ColorTokens.Primary_100 }),
        React.createElement(View, { style: { marginLeft: 12 } },
            React.createElement(Typography, { label: description, color: ColorTokens.Grey_Night, typeDLS: TypographyTypeDLS.B2R }))));
};
const styles = StyleSheet.create({});
export default InterestContent;
